import React from "react";
import { LineDots, LinkButton } from "../../../../core/atoms/atoms";
import * as WebRoutes from "@travellocal/utils/webRoutes";

import "./countrySidebarCta.scss";

interface Props {
  countrySlug: string;
}

export default class CountrySidebarCta extends React.Component<Props, any> {
  public render() {
    return (
      <div className="country-sidebar-cta">
        <h3>Want to go?</h3>
        <LineDots height="30" x1="16%" y1="6px" x2="16%" y2="100%"/>
        <LinkButton
          className="primary-button"
          to={WebRoutes.enquiryForm({ locationSlug: this.props.countrySlug, campaign: "country-page-sidebar" })}
        >
          Plan my trip
        </LinkButton>
        <div className="call-us">
          <span className="text--mid text--label">Or call us on</span>
          <a className="secondary-button" href="tel:+441173257898">
            <img src="/images/flags/currency/GBP.png" height={15} />
            <span>+44 (0)117 325 7898</span>
          </a>
          <a className="secondary-button" href="tel:+18884549902">
            <img src="/images/flags/currency/USD.png" height={15} />
            <span>+1 888 454 9902</span>
          </a>
        </div>
      </div>
    );
  }
}
